import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrowseEligible = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 12,
			fill: "#D5F0F7"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-2-inside-1_15525_2092",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M22 27.5C27.2467 27.5 31.5 23.2467 31.5 18C31.5 12.7533 27.2467 8.5 22 8.5C16.7533 8.5 12.5 12.7533 12.5 18C12.5 23.2467 16.7533 27.5 22 27.5ZM22 24.4C25.5346 24.4 28.4 21.5346 28.4 18C28.4 14.4654 25.5346 11.6 22 11.6C18.4654 11.6 15.6 14.4654 15.6 18C15.6 21.5346 18.4654 24.4 22 24.4Z"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22 27.5C27.2467 27.5 31.5 23.2467 31.5 18C31.5 12.7533 27.2467 8.5 22 8.5C16.7533 8.5 12.5 12.7533 12.5 18C12.5 23.2467 16.7533 27.5 22 27.5ZM22 24.4C25.5346 24.4 28.4 21.5346 28.4 18C28.4 14.4654 25.5346 11.6 22 11.6C18.4654 11.6 15.6 14.4654 15.6 18C15.6 21.5346 18.4654 24.4 22 24.4Z",
			fill: "#4B7987"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.5 18C30.5 22.6944 26.6944 26.5 22 26.5V28.5C27.799 28.5 32.5 23.799 32.5 18H30.5ZM22 9.5C26.6944 9.5 30.5 13.3056 30.5 18H32.5C32.5 12.201 27.799 7.5 22 7.5V9.5ZM13.5 18C13.5 13.3056 17.3056 9.5 22 9.5V7.5C16.201 7.5 11.5 12.201 11.5 18H13.5ZM22 26.5C17.3056 26.5 13.5 22.6944 13.5 18H11.5C11.5 23.799 16.201 28.5 22 28.5V26.5ZM27.4 18C27.4 20.9823 24.9823 23.4 22 23.4V25.4C26.0869 25.4 29.4 22.0869 29.4 18H27.4ZM22 12.6C24.9823 12.6 27.4 15.0176 27.4 18H29.4C29.4 13.9131 26.0869 10.6 22 10.6V12.6ZM16.6 18C16.6 15.0176 19.0176 12.6 22 12.6V10.6C17.9131 10.6 14.6 13.9131 14.6 18H16.6ZM22 23.4C19.0176 23.4 16.6 20.9823 16.6 18H14.6C14.6 22.0869 17.9131 25.4 22 25.4V23.4Z",
			fill: "#1F3B44",
			mask: "url(#path-2-inside-1_15525_2092)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4185 25.4194C16.9261 24.9118 16.9261 24.0886 16.4185 23.581C15.9108 23.0733 15.0877 23.0733 14.58 23.581L9.57998 28.581C9.0723 29.0886 9.0723 29.9118 9.57998 30.4194C10.0877 30.9271 10.9108 30.9271 11.4185 30.4194L16.4185 25.4194Z",
			fill: "#4B7987",
			stroke: "#1F3B44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 14.5L22 15.6547V17.9641L20 19.1188L18 17.9641V15.6547L20 14.5Z",
			fill: "white",
			stroke: "#1F3B44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24 14.5L26 15.6547V17.9641L24 19.1188L22 17.9641V15.6547L24 14.5Z",
			fill: "white",
			stroke: "#1F3B44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 18L24 19.1547V21.4641L22 22.6188L20 21.4641V19.1547L22 18Z",
			fill: "white",
			stroke: "#1F3B44"
		})
	]
});
const ForwardRef = forwardRef(SvgBrowseEligible);
const Memo = memo(ForwardRef);
export default Memo;
